export const ADD_DOMAIN = 'ADD_DOMAIN';

interface AddDomain {
	type: typeof ADD_DOMAIN;
	payload: [];
}

export type DomainsActionTypes = AddDomain;
